import { Link } from 'react-router-dom';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';

import ReCAPTCHAv2 from '~/components/ReCAPTCHAv2';

import './style.css';

const CaptchaView = ({ onChange }) => (
  <div className="captcha-view">
    <Link
      className="lootboyLogo"
      to="/"
    />
    <h3>{I18n.t('CaptchaWebview_headline')}</h3>
    <p>{I18n.t('CaptchaWebview_text')}</p>
    <ReCAPTCHAv2
      siteKey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
      className="captcha"
      onChange={onChange}
    />
  </div>
);

CaptchaView.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default CaptchaView;
